import React from 'react';
import { Row, Col, Typography } from 'antd';
import { FMGModal } from 'components';
import { CheckCircleFilled } from '@ant-design/icons';

interface ConvertModalProps {
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export const ConvertModal: React.FC<ConvertModalProps> = ({ open, onSubmit, onCancel }) => (
  <FMGModal
    width={400}
    title=""
    open={open}
    onSubmit={onSubmit}
    onCancel={onCancel}
    disableOkBtn={false}
    okText="Convert"
  >
    <Row align={'middle'} gutter={[0, 12]} justify={'center'}>
      <CheckCircleFilled style={{ color: '#52c41a', fontSize: 60 }} />
      <Col span={24}>
        <Typography.Title style={{ color: '#222530', textAlign: 'center', margin: 0, padding: 0 }} level={3}>
          Convert Lead
        </Typography.Title>
      </Col>
      <Typography.Text className={'center'}>Are you sure you want to convert Lead?</Typography.Text>
    </Row>
  </FMGModal>
);
